import ContentHeading from './ContentHeading'
import TruckSVG from '../../shared/icons/TruckSVG'
import HalfArrowSVG from '../../shared/icons/HalfArrowSVG'
import HoursSVG from '../../shared/icons/HoursSVG'
import DeliverySVG from '../../shared/icons/DeliverySVG'
import { getIcon } from '../../shared/icons/getIcon'

const ContentHeaderSection = ({ props }) => {
  const { distributionCards, icon, iconBanner, subtitle, text, title } = props

  const DistributionCard = ({ title, text }) => {
    return (
      <div className="dealmed-content-distribution__card">
        <h3 className="dealmed-content-distribution__card-title">{title}</h3>
        <p className="dealmed-content-distribution__card-text">{text}</p>
      </div>
    )
  }

  return (
    <section className="dealmed-content-distribution" aria-label={title}>
      <div className="dealmed-container">
        <ContentHeading icon={getIcon(icon)} subtitle={subtitle} title={title} text={text} />
        <div className="dealmed-content-distribution__body">
          {iconBanner && (
            <div className="dealmed-content-distribution__icons">
              <div className="dealmed-content-distribution__icon-wrapper">
                <TruckSVG className="dealmed-content-distribution__icon" />
              </div>
              <div className="dealmed-content-distribution__icon-wrapper">
                <HalfArrowSVG className="dealmed-content-distribution__icon dealmed-content-distribution__icon--arrow" />
              </div>
              <div className="dealmed-content-distribution__icon-wrapper">
                <HoursSVG className="dealmed-content-distribution__icon" />
              </div>
              <div className="dealmed-content-distribution__icon-wrapper">
                <HalfArrowSVG className="dealmed-content-distribution__icon dealmed-content-distribution__icon--arrow" />
              </div>
              <div className="dealmed-content-distribution__icon-wrapper">
                <DeliverySVG className="dealmed-content-distribution__icon" />
              </div>
            </div>
          )}
          <ul className="dealmed-content-distribution__list">
            {distributionCards.map((card, index) => {
              return (
                <li key={index} className="dealmed-content-distribution__item">
                  <DistributionCard title={card.fields.title} text={card.fields.text} />
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    </section>
  )
}

export default ContentHeaderSection
